import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import SendPushForm from '../components/SendPushForm';
import * as sitesActions from '../actions/sites';
import * as sitesApi from '../api/sites';
import routes from '../routes';
import * as authService from '../services/auth';

const SendPushView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const site = useSelector((state) => state.app.site);
  const siteUsers = useSelector((state) => state.entities.sites.users);

  useEffect(() => {
    if (!location.state || !location.state.usersIds) {
      history.push(routes.index);
    }

    dispatch(sitesActions.fetchSiteUsers(site.id));
  }, [site.id, dispatch]);

  const handleSubmit = (values) => {
    const currentlyLoggedInOrImpersonatingUser = authService.getCurrentlyLoggedInOrImpersonatingUser();
    const groupId = location.state && location.state.groupId;

    return sitesApi.sendSitePush(site.id, {
      ...values,
      created_by_id: currentlyLoggedInOrImpersonatingUser.id,
      ...(groupId ? { group_id: groupId } : {}),
    });
  };

  if (siteUsers.inflight || siteUsers.bySiteId[site.id] === undefined) {
    return 'Loading users...';
  }

  // Push has no per-user "verified" flag: we send to every selected user and the
  // backend silently skips those with no registered device.
  const recipients = siteUsers.bySiteId[site.id].filter((r) => location.state.usersIds.indexOf(r.id) !== -1);

  return (
    <Box mb={12}>
      <Breadcrumbs aria-label="Breadcrumbs">
        <Typography color="textPrimary">Send Push</Typography>
      </Breadcrumbs>

      <SendPushForm
        recipients={recipients}
        submitCallback={handleSubmit}
        groupName={location.state && location.state.groupName}
      />
    </Box>
  );
};

export default SendPushView;
